module.exports = __webpack_public_path__ + "media/images/application/template/queens-innovation-d53ce7ffbeb6d7db594f503248809746.png";